// import { Component } from '@angular/core';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';
import { UploadService } from '../../services/upload/upload.service';
import { DmsFile } from '../../modal/upload/model/upload.model';

@Component({
  selector: 'app-preparation-of-psqr-fromm-pdd',
  standalone:false,
  templateUrl: './preparation-of-psqr-fromm-pdd.component.html',
})
export class PreparationOfPsqrFrommPddComponent implements OnInit  {
  commentForm: FormGroup;
  @Output() routeConfig = new EventEmitter<any>();
  @Input() stepDetails: any;
  @Input() proposalName: any;
  @Input() url: string;
  apiResponse: any;
  init: EditorComponent['init'] = init;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: ApiService
  ) {
    this.commentForm = this.fb.group({
      justification: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.getDetails();
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
        this.commentForm.enable();
      } else {
        this.commentForm.disable();
      }
    }, 3000);
  }

  onSubmit(): void {
    const formData = new FormData();
    formData.append('proposal_step', this.stepDetails.id);
    formData.append('justification', this.commentForm.get('justification')?.value || '');
    const req = this.apiResponse?.id
      ? this.api.putAPI(`${this.url}${this.apiResponse.id}/`, formData)
      : this.api.postAPI(this.url, formData);
    req.subscribe((res: any) => {
      this.getDetails();
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res.message || (this.apiResponse?.id ? 'Data updated successfully' : 'Data uploaded successfully')
      });
    });
  }

  getDetails(): void {
    this.api.getAPI(`${this.url}?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`)
      .subscribe((res: any) => {
        this.apiResponse = res[0];
        this.commentForm.patchValue(this.apiResponse);
      });
  }
}
